var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTooltip),expression:"showTooltip"}],staticClass:"baseTooltip"},_vm._l((_vm.value),function(v){return _c('span',{key:v,staticClass:"Rule-Selection"},[_c('div',{domProps:{"textContent":_vm._s(v)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }